import { Environment } from './Environment.interface';

const domain = 'sgr5dev.prevsis.com';
const gateway = `https://api.${domain}/api`;

export const environment: Environment = {
  production: false,
  mf: {
    components: {
      sidebar: {
        sidebarComponent: {
          remoteEntry: `https://${domain}/mf-sidebar/mf-sidebar.js`,
          exposedModule: './sidebarComponent',
        },
      },
      account: {
        accountComponent: {
          remoteEntry: `https://${domain}/mf-account/mf-account.js`,
          exposedModule: './accountComponent',
        },
        configurationComponent: {
          remoteEntry: `https://${domain}/mf-account/mf-account.js`,
          exposedModule: './configurationComponent',
        },
        loadingComponent: {
          remoteEntry: `https://${domain}/mf-account/mf-account.js`,
          exposedModule: './loadingComponent',
        },
        homeComponent: {
          remoteEntry: `https://${domain}/mf-account/mf-account.js`,
          exposedModule: './homeComponent',
        },
        loginComponent: {
          remoteEntry: `https://${domain}/mf-account/mf-account.js`,
          exposedModule: './loginComponent',
        },
        recoveryComponent: {
          remoteEntry: `https://${domain}/mf-account/mf-account.js`,
          exposedModule: './recoveryComponent',
        },
        settingsComponent: {
          remoteEntry: `https://${domain}/mf-account/mf-account.js`,
          exposedModule: './settingsComponent',
        },
        listUsersComponent: {
          remoteEntry: `https://${domain}/mf-account/mf-account.js`,
          exposedModule: './listUsersComponent',
        },
        inviteconfirmComponent: {
          remoteEntry: `https://${domain}/mf-account/mf-account.js`,
          exposedModule: './inviteconfirmComponent',
        },
        marketplaceComponent: {
          remoteEntry: `https://${domain}/mf-account/mf-account.js`,
          exposedModule: './marketplaceComponent',
        },
        generalComponent: {
          remoteEntry: `https://${domain}/mf-account/mf-account.js`,
          exposedModule: './generalComponent',
        },
      },
      masterforms: {
        masterFormsComponent: {
          remoteEntry: `https://${domain}/mf-master-forms/mf-master-forms.js`,
          exposedModule: './masterFormsComponent',
        },
        listFormSystemComponent: {
          remoteEntry: `https://${domain}/mf-master-forms/mf-master-forms.js`,
          exposedModule: './listFormSystemComponent',
        },
        listFormsComponent: {
          remoteEntry: `https://${domain}/mf-master-forms/mf-master-forms.js`,
          exposedModule: './listFormsComponent',
        },
        reviewFormComponent: {
          remoteEntry: `https://${domain}/mf-master-forms/mf-master-forms.js`,
          exposedModule: './reviewFormComponent',
        },
        listGlobalFieldsComponent: {
          remoteEntry: `https://${domain}/mf-master-forms/mf-master-forms.js`,
          exposedModule: './listGlobalFieldsComponent',
        },
        globalFieldEditorComponent: {
          remoteEntry: `https://${domain}/mf-master-forms/mf-master-forms.js`,
          exposedModule: './globalFieldEditorComponent',
        },
        statusManagementComponent: {
          remoteEntry: `https://${domain}/mf-master-forms/mf-master-forms.js`,
          exposedModule: './statusManagementComponent',
        },
      },
      view: {
        viewComponent: {
          remoteEntry: `https://${domain}/mf-view/mf-view.js`,
          exposedModule: './viewComponent',
        },
      },
      org: {
        orgComponent: {
          remoteEntry: `https://${domain}/mf-organizational-levels/mf-organizational-levels.js`,
          exposedModule: './orgComponent',
        },
        listsComponent: {
          remoteEntry: `https://${domain}/mf-organizational-levels/mf-organizational-levels.js`,
          exposedModule: './listsComponent',
        },
        accreditationConfigComponent: {
          remoteEntry: `https://${domain}/mf-organizational-levels/mf-organizational-levels.js`,
          exposedModule: './accreditationConfigComponent',
        },
        masterPlannerComponent: {
          remoteEntry: `https://${domain}/mf-organizational-levels/mf-organizational-levels.js`,
          exposedModule: './masterPlannerComponent',
        },
        plannerComponent: {
          remoteEntry: `https://${domain}/mf-organizational-levels/mf-organizational-levels.js`,
          exposedModule: './plannerComponent',
        },
      },
      wallet: {
        walletsManagementComponent: {
          remoteEntry: `https://${domain}/mf-wallet/mf-wallet.js`,
          exposedModule: './walletsManagementComponent',
        },
      },
      templateEditor: {
        templateEditorComponent: {
          remoteEntry: `https://${domain}/mf-template-editor/mf-template-editor.js`,
          exposedModule: './templateEditorComponent',
        },
      },
    },
    modules: {
      previn: {
        remoteEntry: `https://${domain}/mf_previn/mf_previn.js`,
        exposedModule: './PrevinRemoteModule',
      },
      masterFlow: {
        remoteEntry: `https://${domain}/mf-flow/mf-flow.js`,
        exposedModule: './FlowBuilderModule',
      },
      flow: {
        remoteEntry: `https://${domain}/mf-flow/mf-flow.js`,
        exposedModule: './FlowViewModule',
      },
      planner: {
        remoteEntry: `https://${domain}/mf-planner/mf-planner.js`,
        exposedModule: './plannerBuilderModule',
      },
      profile: {
        remoteEntry: `https://${domain}/mf-account/mf-account.js`,
        exposedModule: './ProfileModule',
      },
    },
  },
  // Email / PDF dispatch used by the design-system CommunicationDispatchService
  // (conditional-rule Send email / Send PDF / Notification). The shell provides
  // ENVIRONMENT to the library, so it must be defined here, not only in mf-view.
  templateApi: {
    pdfEndpoint: `${gateway}/post_pdf`,
    emailEndpoint: `${gateway}/sendgrid`,
    templates: {
      emailDefault: '341ef752-4c4a-4778-b41a-9c079e5579bf',
      emailCustomGeneral: 'bb050e3d-faff-4508-b649-5cf8c9461f52',
      emailCustomAcreditacion: '91a96dd2-4d99-4339-9779-3065d3564b9a',
      pdfDefault: 'c724e24b-f1e8-4033-8eae-8a239e7d25d2',
      pdfEstandaresMinimos: 'b74f38b0-5c10-45f9-90ac-062a49d796a2',
      pdfCustomVisionZero: 'c885452c-b198-4a37-a191-09abc0b61288',
      pdfCustomMatrizRiesgo: '3f2fa39b-6fff-4b36-9169-d5f43d83ca4e',
    },
  },
  url: {
    gateway,
    profiling: `${gateway}/ms-profiling`,
    master_forms: `${gateway}/master-forms`,
    accounts: `${gateway}/accounts`,
    org: `${gateway}/ms-organizational-levels`,
    files: `${gateway}/file`,
    datasources: `${gateway}/datasources`,
    main_domain: domain,
    searchFilter: `${gateway}/search-filter`,
    planner: `${gateway}/planner`,
  },
  inactivityTimeoutInMinutes: 30, // 30 minutes
  dataDog: {
    applicationId: 'f39fb180-2012-4de7-9f9d-2f53ae8e266c',
    clientToken: 'pube5e8a719fcd8cd566256ee2f4814e787',
    site: 'us5.datadoghq.com',
    service: 'dev-sgr5-new',
    env: 'dev',
    trackViewsManually: true,
  },
};
